<template>
  <div class="container">
    <div class="modal">
     <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    
  }
</script>
<style scoped>
.container{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(146, 153, 187, 0.356);
  backdrop-filter: blur(2px);

  display: flex;
  justify-content: center;
  align-content: center;
}

.modal{
  width: fit-content;
  min-width: 10rem;
  height: 30rem;
  border-radius: 1rem;
  background: #FFFFFF;
  margin: 0 auto;
  padding: 1rem;
}
</style>